import { render, staticRenderFns } from "./PmOmOrderList.vue?vue&type=template&id=6f0ec3db&scoped=true&"
import script from "./PmOmOrderList.vue?vue&type=script&lang=js&"
export * from "./PmOmOrderList.vue?vue&type=script&lang=js&"
import style0 from "./PmOmOrderList.vue?vue&type=style&index=0&id=6f0ec3db&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f0ec3db",
  null
  
)

export default component.exports